import React, {Component} from 'react';

export class SubmitButton extends Component {
    constructor(props) {
        super(props);

        this.handleClick = this.handleClick.bind(this);
    }

    renderClassName(){
        if(this.props.className){
            return "btn -alt " + this.props.className;
        }
        return "btn -alt";
    }

    render() {
        return (
            <input type="submit" onClick={this.handleClick} value={this.props.value} className={this.renderClassName()}/>
        )
    }

    handleClick(event) {
        event.preventDefault();
        this.props.onClick();
    }
}

